export const UNCERTAINTY_CODES = [
  'attest_reject',
  'missing_attachment',
  'account_unreliable',
  'vat_unreliable',
  'split_uncertain',
  'no_seed'
] as const

export type UncertaintyCode = (typeof UNCERTAINTY_CODES)[number]

export type UncertaintySection = 'header' | 'accounts' | 'attachments'

export type UncertaintySeverity = 'error' | 'warning' | 'info'

export const UNCERTAINTY_SECTION: Record<UncertaintyCode, UncertaintySection> = {
  attest_reject: 'header',
  missing_attachment: 'attachments',
  account_unreliable: 'accounts',
  vat_unreliable: 'accounts',
  split_uncertain: 'accounts',
  no_seed: 'header'
}

export const UNCERTAINTY_SEVERITY: Record<UncertaintyCode, UncertaintySeverity> = {
  attest_reject: 'error',
  missing_attachment: 'warning',
  account_unreliable: 'warning',
  vat_unreliable: 'warning',
  split_uncertain: 'warning',
  no_seed: 'info'
}

export const isUncertaintyCode = (value: string): value is UncertaintyCode =>
  (UNCERTAINTY_CODES as readonly string[]).includes(value)
